module.exports = __webpack_public_path__ + "img/email.8103a30a.svg";